import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import moment from 'moment';
import { connect } from 'react-redux';
import { NotificationInfosApi } from '../../../redux/api/NotificationInfosApi';
import { getNotificationsLatest } from '../../../redux/actions/Notification';
import { NotificationType } from '../../../constants/ComponentTypes';
import { FLAG } from '../../../constants/Constants';

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  box: {
    padding: '15px 25px',
    background: '#FFF6F0',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: 5,
    boxSizing: 'border-box',
    marginBottom: 25,
  },

  detail: {
    fontSize: 14,
    marginTop: 10,
    color: '#A0522D',
    whiteSpace: 'pre-wrap',
  },

  date: {
    fontSize: 12,
    marginTop: 10,
    color: '#A0522D',
  },
});

/**
 * 日程が未確定の商談の通知（毎朝のバッチが作る画面内通知）をダッシュボードに出すパネル
 *
 * 未読の通知だけを取得して表示し、表示した時点で既読にする。
 * そのため、一度表示した通知は次にダッシュボードを開いたときには表示されない。
 * ただし代理ログイン中は、本人が見られなくならないようAPI側で既読にしない。
 */
class PendingAppointmentScheduleNotification extends React.Component {
  state = {
    notifications: [],
  }

  componentDidMount() {
    this.isUnmounted = false;
    if (this.props.isDemo) {
      return;
    }
    this.fetchAndMarkRead();
  }

  componentWillUnmount() {
    // 取得が終わる前にダッシュボードから移動したときに、setStateしないようにする
    this.isUnmounted = true;
  }

  fetchAndMarkRead = () => {
    const { dispatch } = this.props;
    NotificationInfosApi.getNotifications(
      {
        type: NotificationType.PENDING_APPOINTMENT_SCHEDULE,
        read_flag: FLAG.OFF,
      },
      dispatch
    )
      .then((response) => {
        const notifications = response.data.data || [];
        if (notifications.length === 0) {
          return;
        }
        if (!this.isUnmounted) {
          this.setState({ notifications });
        }
        // 表示したものは既読にして、次回以降は表示しない（代理ログイン中はAPI側で既読にしない）
        const markRequests = notifications.map((item) => (
          NotificationInfosApi.postNotificationsMark(item.id, { read_flag: FLAG.ON }, dispatch)
            .catch(() => {})
        ));
        // ヘッダーのベルの未読表示を、既読にした結果に合わせる
        Promise.all(markRequests).then(() => dispatch(getNotificationsLatest()));
      })
      .catch(() => {});
  }

  render() {
    const { classes } = this.props;
    const { notifications } = this.state;
    if (notifications.length === 0) {
      return <div></div>;
    }

    return (
      <div className={classes.root}>
        {notifications.map((item) => (
          <div className={classes.box} key={item.id}>
            <Typography variant="display1" style={{ color: '#A0522D', fontSize: 16 }}>
              {item.message_head}
            </Typography>
            <div className={classes.detail}>{item.message_body}</div>
            <div className={classes.date}>
              通知日：{moment(item.created_at).format('YYYY年MM月DD日')}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

PendingAppointmentScheduleNotification.propTypes = {
  classes: PropTypes.object.isRequired,
  isDemo: PropTypes.bool,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isDemo: state.accountSetting.showDemoData,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(PendingAppointmentScheduleNotification));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/PendingAppointmentScheduleNotification.jsx